import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {Partenaires} from "./Home/Partenaires";
import EditoService from "../service/EditoSevice";

import maison from './../assets/images/maison.svg';

export const Edito = ({idContent}) => {
    const[content, setContent] = useState([]);
    const[loadingContent, setLoadingContent] = useState(1);
    const fetchContent = async(idContent) => {
        try{
            const data = await EditoService.find(idContent);
            setContent(data);
            setLoadingContent(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchContent(idContent);
    }, [idContent]);

    return (
        <>
            <Helmet>
                <title>{content.meta_title}</title>
                <meta name="description" content={content.meta_desc} />
            </Helmet>
            <main>
                <section className="bg-white pb-5">
                    <div className="container px-4 pb-5 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href="/" className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            {content.titre}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="display-5 fw-sb mb-3">{content.titre}</h1>
                            </div>
                        </div>
                        <div className="row g-0 align-items-stretch justify-content-center">
                            <div className="col-lg-10" dangerouslySetInnerHTML={{__html : content.contenu}}>

                            </div>
                        </div>
                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    )
}